import * as React from "react";
import * as program from "./program.module.scss";
import { programData } from "./data/programData";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { styled } from '@mui/material';

const StyledAccordion = styled(Accordion)({
  boxShadow: "unset",
  backgroundColor: "unset",
  "&::before": {
    display: "none"
  }
});

const StyledSummary = styled(AccordionSummary)({
  fontSize: "28px",
  lineHeight: "32px",
  fontWeight: "700",
  color: "#232323",
  background: "linear-gradient(93.92deg, #FFE8E8 0%, #FFDADA 100%)",
  borderRadius: "20px",
  padding: "20px 20px 20px 85px",
  "@media (max-width: 991px)": {
    fontSize: "24px",
    lineHeight: "28px",
    padding: "20px 20px 20px 70px",
  },
  "@media (max-width: 767px)": {
    fontSize: "18px",
    lineHeight: "18px",
    padding: "20px 20px 20px 40px",
  },
  "&:after": {
    content: "''",
    position: "absolute",
    top: "23%",
    left: "27px",
    width: "43px",
    height: "43px",
    backgroundImage: "url(https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_vashih_celey/_program/arrow-down.svg)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    "@media (max-width: 991px)": {
      top: "19%",
      left: "15px",
      backgroundSize: "36px",
    },
    "@media (max-width: 767px)": {
      top: "14%",
      left: 0,
      backgroundSize: "20px",
    },
  },
  "&.Mui-expanded": {
    background: "linear-gradient(93.92deg, #FE4C04 0%, #FF814E 100%)",
    borderTopRightRadius: "20px",
    borderTopLeftRadius: "20px",
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    color: "#ffffff",
    "&:after": {
      backgroundImage: "url(https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_vashih_celey/_program/arrow-up.svg)"
    }
  },
  ".MuiAccordionSummary-content": {
    margin:0
  },
});

const StyledDetails = styled(AccordionDetails)({
  fontSize: "20px",
  lineHeight: "23px",
  fontWeight: 400,
  backgroundColor: "#ffffff",
  color: "rgba(35, 35, 35, 1)",
  boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.15)",
  borderBottomRightRadius: "20px",
  borderBottomLeftRadius: "20px",
  padding: "30px 40px 40px 50px",
  "@media (max-width: 991px)": {
    fontSize: "16px",
    lineHeight: "18px",
  },
  "@media (max-width: 767px)": {
    fontSize: "14px",
    lineHeight: "16px",
    padding: "20px 20px 20px 20px"
  }
})

export const Program = ({ data={ programData } }) => {

  return (
    <section className={program.program}>
      <div className="container">
        <h2 className={program.program__title}>Структура курса и уроков</h2>
        <div className={program.program__wrapper}>
          {programData.map((elem, index) => (
            <StyledAccordion
              className={program.program__block}
              key={index}
              disableGutters={true}
              square
            >
              <StyledSummary>
                {elem.theme}
              </StyledSummary>
              <StyledDetails className={program.program__block_body}>
                {elem.explanation}
              </StyledDetails>
            </StyledAccordion>
          ))}
        </div>
      </div>
    </section>
  );
};
